import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'core/components/button';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import useStyles from './migrated-rerun-confirm-modal.styles';

// #37141: Mutual Services' wording, verbatim.
export const MIGRATED_RERUN_WARNING =
  'Changing this field will rerun the replacement cost estimate and may change the Coverage A limit and premium. Do you want to continue?';

/**
 * #37141: asks before a migrated dwelling's 360Value field is changed (see useMigrated360RerunConfirm). Closing
 * the dialog any other way is a Cancel.
 */
const MigratedRerunConfirmModal = ({ onContinue, onCancel }) => {
  const classes = useStyles();
  return (
    <BaseDialog className={classes.modal} onClose={onCancel} open>
      <div className={classes.container}>
        <Label type="subtitle1Regular">{MIGRATED_RERUN_WARNING}</Label>
        <div className={classes.buttonContainer}>
          <Button className={classes.buttons} variant="contained" color="primary" onClick={onContinue}>
            Continue
          </Button>
          <Button className={classes.buttons} variant="contained" color="secondary" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </BaseDialog>
  );
};

MigratedRerunConfirmModal.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default MigratedRerunConfirmModal;
